import { create } from "zustand";

interface ModalState {
  openModals: Record<number, boolean>;
  openModal: (index: number) => void;
  closeModal: (index: number) => void;
}

export const useDynamicStore = create<ModalState>((set) => ({
  openModals: {},
  openModal: (index) =>
    set((state) => ({
      openModals: { ...state.openModals, [index]: true },
    })),
  closeModal: (index) =>
    set((state) => ({
      openModals: { ...state.openModals, [index]: false },
    })),
}));